import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { isEmptyButtonLabel } from '@common/helpers/forms';
import { WebBaseControlTypedSettingsComponent } from '@web/widgets/common/abstract/web-base-control-typed-settings.component';
import { EButtonStyleType, type ESize } from '@common/enums';
import { ButtonMode, type CustomButtonEventPayload } from '@components/sp-custom-button/type/custom-button.type';
import { ERadioGroupType } from '@ui/sp-radio-group';
import { ThemeStateService } from '@sites/site-theme/src/state';
import type { CatalogBasketButtonFormGroup, CatalogBasketButtonFormType } from '@web/widgets/catalog-products/type';
import type { ButtonIcon } from '@components/sp-button-icon/type/button-icon.type';
import { CommonModule } from '@angular/common';
import { CommonElementsModule } from '@web/widgets/common/common-elements.module';
import { SpCustomButtonModule } from '@components/sp-custom-button';
import { SpButtonIconComponent } from '@components/sp-button-icon';

@Component({
    selector: 'web-button-settings',
    templateUrl: './button-settings.component.html',
    styleUrls: ['./button-settings.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, CommonElementsModule, SpCustomButtonModule, SpButtonIconComponent],
})
export class ButtonSettingsComponent extends WebBaseControlTypedSettingsComponent<CatalogBasketButtonFormGroup> {
    private readonly themeState = inject(ThemeStateService);

    protected readonly EButtonStyleType = EButtonStyleType;
    protected readonly ButtonMode = ButtonMode;
    protected readonly ERadioGroupType = ERadioGroupType;

    public readonly selectedThemeColors = this.themeState.selectedColors;

    public get saveDisablePredicate(): boolean {
        return isEmptyButtonLabel(this.label?.value);
    }

    public setSize(value: string): void {
        this.size.setValue(value as ESize);
    }

    public customButtonChangeHandler(changes: CustomButtonEventPayload): void {
        this.buttonBase.setValue(changes.base);
        this.buttonHover.setValue(changes.hover);
    }

    public buttonIconChangeHandler(changes: ButtonIcon): void {
        this.buttonIcon.setValue(changes);
    }

    public get styleType(): CatalogBasketButtonFormType['styleType'] {
        return this.itemForm.get('styleType') as CatalogBasketButtonFormType['styleType'];
    }

    public get label(): CatalogBasketButtonFormType['label'] {
        return this.itemForm.get('label') as CatalogBasketButtonFormType['label'];
    }

    public get buttonBase(): CatalogBasketButtonFormType['buttonBase'] {
        return this.itemForm.get('buttonBase') as CatalogBasketButtonFormType['buttonBase'];
    }

    public get buttonHover(): CatalogBasketButtonFormType['buttonHover'] {
        return this.itemForm.get('buttonHover') as CatalogBasketButtonFormType['buttonHover'];
    }

    public get action(): CatalogBasketButtonFormType['action'] {
        return this.itemForm.get('action') as CatalogBasketButtonFormType['action'];
    }

    public get size(): CatalogBasketButtonFormType['size'] {
        return this.itemForm.get('size') as CatalogBasketButtonFormType['size'];
    }

    public get buttonIcon(): CatalogBasketButtonFormType['buttonIcon'] {
        return this.itemForm.get('buttonIcon') as CatalogBasketButtonFormType['buttonIcon'];
    }
}
